'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import React from 'react';
import { FieldError, UseFormRegister, Path } from 'react-hook-form';

/**
 * Based on existing component for Club registration.
 * Can be used as generic component.
 */
export default function PrivacyPolicyCheckBox<T extends { privacyPolicy: boolean }>({
  register,
  errors,
  internalPagesLinksKey = 'dataPrivacyPolicy',
}: {
  register: UseFormRegister<T>;
  errors: FieldError | undefined;
  internalPagesLinksKey?: string;
}) {
  const t = useTranslations('PrivacyPolicyCheckbox');
  const internalPagesLinks = useTranslations('internalPagesLinks');

  return (
    <div className="space-y-1">
      <div className="flex space-x-2">
        <input
          id="privacyPolicy"
          type="checkbox"
          {...register('privacyPolicy' as Path<T>)}
          className="h-4 w-4"
        />
        <label htmlFor="privacyPolicy" className="text-sm text-neutral-50">
          {t.rich('privacyPolicyLabelText', {
            dataPrivacyPolicy: (chunks) => (
              <Link className="underline" href={internalPagesLinks(internalPagesLinksKey)}>
                {chunks}
              </Link>
            ),
          })}
        </label>
      </div>
      {errors && <p className="text-sm text-red">{errors.message}</p>}
    </div>
  );
}
